import axiosInstance from "../utils/axiosInstance";

const fetchAllForms = url => axiosInstance.get(url).then(response => response);

export default fetchAllForms;
